import lotsMapping from "../Data/lotsBackground.json";

const imagesContext = (require as any).context(
  "../assets/image-lot",
  false,
  /\.(png|jpe?g)$/
);

export const getLotImage = (lotName: string) => {
  // Cherche le lot correspondant dans le JSON
  const lot = lotsMapping?.find((l) => {
    const nameNormalized = l.lot_name
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // supprime les accents
      .trim();
    const lotNameNormalized = lotName
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
    return nameNormalized === lotNameNormalized;
  });

  if (!lot) return imagesContext("./default.jpg");

  const fileName = lot?.nom_fichier;

  try {
    return imagesContext(`./${fileName}`);
  } catch (err) {
    console.warn(`Image non trouvée pour le lot : ${lotName}`);
    return imagesContext("./default.jpg");
  }
};
